import { Button, Result } from "antd";
import React from "react";

import { NavLink } from "react-router-dom";
import { useSession } from "../../auth/session";

export default function Page404() {
  const { user } = useSession();
  return (
    <Result
      status="404"
      title="404"
      subTitle="Xin lỗi,trang không tồn tại"
      extra={
        user?.data.type === "CUSTOMER" ? (
          <NavLink to={"/info-point-store"}>
            <Button type="primary">Quay về trang chủ</Button>
          </NavLink>
        ) : (
          <NavLink to={"/"}>
            <Button type="primary">Quay về trang chủ</Button>
          </NavLink>
        )
      }
    />
  );
}
